// extracted by mini-css-extract-plugin
export default {"layout":"layout___Lxbjq","title":"title___Eg7nd","quote":"quote___qzWY_","quoteText":"quoteText___v7B9k"};